export enum BoxesSliderSlideSize {
  Small = 'small',
  Big = 'big',
}
